'use strict';
const includes = require('lodash/includes');
const keys = require('lodash/keys');
const values = require('lodash/values');
const uniq = require('lodash/uniq');
const zipObject = require('lodash/zipObject');

const TPA_WIDGET_TYPE = 'wysiwyg.viewer.components.tpapps.TPAWidget';

class TypeUtils {
  constructor(typesData) {
    this._typesData = typesData;
  }

  getSdkType (viewerType, tpaWidgetId) {
    const typesData = this._typesData;
    const sdkTypeByViewerType = typesData.sdkTypeByViewerType;
    const sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;
    const defaultSdkType = typesData.defaultSdkType;

    if (tpaWidgetId && viewerType !== TPA_WIDGET_TYPE) {
      throw new Error(`tpaWidgetId is only supported with viewer type [${TPA_WIDGET_TYPE}]`);
    }

    return sdkTypeByWidgetId[tpaWidgetId] || sdkTypeByViewerType[viewerType] || defaultSdkType;
  }

  getFullSdkType (viewerType, tpaWidgetId) {
    return `$w.${this.getSdkType(viewerType, tpaWidgetId)}`;
  }

  getPotentialViewerTypes (sdkType) {
    const typesData = this._typesData;
    const sdkTypeByViewerType = typesData.sdkTypeByViewerType;
    const sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

    const resultViewerTypes = keys(sdkTypeByViewerType).filter(viewerType => sdkTypeByViewerType[viewerType] === sdkType);
    const isPotentiallyTPA = includes(values(sdkTypeByWidgetId), sdkType);
    if (isPotentiallyTPA) {
      resultViewerTypes.push('wysiwyg.viewer.components.tpapps.TPAWidget');
    }
    return resultViewerTypes;
  }

  get Types () {
    const typesData = this._typesData;
    const sdkTypeByViewerType = typesData.sdkTypeByViewerType;
    const sdkTypeByWidgetId = typesData.sdkTypeByWidgetId;

    const allSdkTypes = uniq(values(sdkTypeByViewerType).concat(values(sdkTypeByWidgetId)));
    return zipObject(allSdkTypes, allSdkTypes);
  }

  get defaultSdkType () {
    const typesData = this._typesData;
    return typesData.defaultSdkType;
  }
}

module.exports = TypeUtils;



// WEBPACK FOOTER //
// ./src/typeUtils/typeUtils.js